export default "/images/f82a312aa19ee23051d32ecaf185c9d9.avif";